import { PlayerPage } from './pages/PlayerPage';
import { SplashPage } from './pages/SplashPage';
import { Backend } from './api/Backend';
import { LoginPage } from './pages/profile/LoginPage';
import Request from '@lightningjs/sdk/src/Router/model/Request';
import { MainPage } from './pages/main/MainPage';
import { FatalErrorScreen } from './pages/FatalErrorScreen.component';

export default {
  root: () => Promise.resolve(Backend.instance.rootPage),
  beforeEachRoute: (fromHash: string, toRequest: Request) => {
    if (toRequest.hash === '$' || toRequest.hash.startsWith('login') || toRequest.hash.startsWith('fatalError')) {
      return Promise.resolve(true);
    }
    const backend = Backend.instance;
    if (!backend.isAuthorized()) {
      return Promise.resolve('login');
    } else {
      return Promise.resolve(true);
    }
  },
  routes: [
    {
      path: '$',
      component: SplashPage,
      options: {
        preventStorage: true,
      },
    },
    {
      path: 'play',
      component: PlayerPage,
      widgets: ['Dialog', 'PlayerModal'],
      options: {
        preventStorage: true,
      },
      on: (page: any) => {
        return new Promise<void>(resolve => {
          page.backend = Backend.instance;
          resolve();
        });
      },
    },
    {
      path: 'login',
      component: LoginPage,
      options: {
        preventStorage: true,
      },
      widgets: ['Dialog'],
      on: (page: any) => {
        return new Promise<void>(resolve => {
          if (!page.params || !page.params.backend) {
            page.params = {
              backend: Backend.instance,
            };
          }
          resolve();
        });
      },
    },
    {
      path: 'main',
      component: MainPage,
      widgets: ['Modal', 'Dialog', 'Toasts'],
      on: (page: any) => {
        return new Promise<void>(resolve => {
          if (!page.params || !page.params.backend) {
            page.params = {
              backend: Backend.instance,
            };
          }
          resolve();
        });
      },
    },
    {
      path: 'fatalError',
      component: FatalErrorScreen,
      options: {
        preventStorage: true,
      },
      on: (page: any) => {
        return new Promise<void>(resolve => {
          if (!page.params || !page.params.backend) {
            page.params = {
              backend: Backend.instance,
            };
          }
          resolve();
        });
      },
    },
  ],
};
